import { Slot } from '@bcraft-frontend-lib/slots'

import { toFilterCategoryKey } from 'modules/SlotsRoot/utils/categoryName'
import { deduplicateSlots } from 'modules/SlotsRoot/utils/deduplicateSlots'

const RESERVED_CATEGORY_NAMES = new Set(['all', 'favorite'])

type CategoryWithSlots = {
  id: string
  name: string
  slots: Slot[]
}

export const buildFilterCategoryNames = (categories: { name: string }[]) => {
  const categoryKeys = categories
    .filter(({ name }) => !RESERVED_CATEGORY_NAMES.has(name.toLowerCase()))
    .map(({ name }) => toFilterCategoryKey(name))
    .filter(Boolean)

  return ['all', 'favorite', ...Array.from(new Set(categoryKeys))]
}

export const isAllCategorySelected = (selectedCategories: string[] | null | undefined): boolean => {
  if (!selectedCategories?.length) {
    return true
  }

  return selectedCategories.length === 1 && toFilterCategoryKey(selectedCategories[0]) === 'all'
}

export const getAllCategorySlots = (listWithSlots: CategoryWithSlots[]): Slot[] => {
  const allCategory = listWithSlots.find(category => category.name.toLowerCase() === 'all')

  return allCategory ? deduplicateSlots(allCategory.slots) : []
}

export const filterSlotsByFavorite = (
  slots: Slot[],
  selectedCategories: string[],
  favoriteSlotIds: Slot['id'][],
) => {
  if (!selectedCategories.some(category => toFilterCategoryKey(category) === 'favorite')) {
    return slots
  }

  const favoriteIds = new Set(favoriteSlotIds)

  return slots.filter(slot => favoriteIds.has(slot.id))
}

export const filterSlotsBySelectedCategory = (
  allSlots: Slot[],
  listWithSlots: CategoryWithSlots[],
  selectedCategories: string[],
  favoriteSlotIds: Slot['id'][],
): Slot[] => {
  const selected = selectedCategories || []

  if (selected.some(category => toFilterCategoryKey(category) === 'favorite')) {
    return filterSlotsByFavorite(allSlots, selected, favoriteSlotIds)
  }

  if (isAllCategorySelected(selected)) {
    return allSlots
  }

  const selectedKeys = new Set(selected.map(category => toFilterCategoryKey(category)))

  const categorySlots = listWithSlots
    .filter(category => selectedKeys.has(toFilterCategoryKey(category.name)))
    .flatMap(category => category.slots)

  return deduplicateSlots(categorySlots)
}
